module.exports = __webpack_public_path__ + "static/img/product1-2.db935d15.png";